<template>
    <div>
        <div class="d-flex justify-content-center pt-5">
            <b-spinner label="Spinning" type="grow" variant="primary"></b-spinner>
        </div>

        <b-modal
            ref="save-modal"
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            hide-header
            @cancel="onCancel"
            @ok="onSave"
            ok-title="Save"
            :modal-class="modalClasses"
            :visible="this.currentState.matches('cancel') === false
                && this.currentState.matches('submitted') === false"
            :cancel-disabled="this.currentState.matches('idle') === false"
            :ok-disabled="this.currentState.matches('idle') === false"
        >
            <div v-if="title == null && url == null"
                class="d-block text-center">
                <b-spinner
                    label="Spinning"
                    type="grow"
                    variant="primary"></b-spinner>
            </div>
            <div v-else>
                <h4 v-if="title != null">{{title}}</h4>
                <p v-if="url != null">
                    {{url}}
                </p>
            </div>
            <div v-if="currentState.matches('idle.invalid')" class="mt-2">
                <b-alert
                    class="mb-0"
                    show
                    variant="danger">{{context.validationErrorMessage}}</b-alert>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {createShareIntentMachine} from "./createShareIntentMachine.js";
import {interpret} from "xstate";
import {inspect} from '@xstate/inspect';

export default {
    name: "ShareIndex",
    data() {
        const shareIntentMachine = createShareIntentMachine({
            services: {
                navigateAway: () => {
                    FL?.log?.debug("[share] navigateAway called");
                    return new Promise(() => {
                        window.location = "/";
                    });
                }
            }
        });
        return {
            modalClasses: ["ShareIntentModal"],
            formService: interpret(shareIntentMachine, {
                devTools: process.env.NODE_ENV === 'development'
            }),
            currentState: shareIntentMachine.initialState,
            context: shareIntentMachine.context,
            title: null,
            text: null,
            url: null,
        };
    },
    created() {
        this.formService
            .onTransition((state) => {
                this.currentState = state;
                this.context = state.context;
            })
            .start();
    },
    mounted() {
        this.$nextTick(() => {
            const parsedUrl = new URL(window.location);
            this.title = parsedUrl.searchParams.get('title');
            let url = parsedUrl.searchParams.get('url');
            if (url == null) {
                url = parsedUrl.searchParams.get('text');
            }
            this.url = url;
        });
    },
    methods: {
        onCancel(bvModalEvt) {
            FL?.log?.debug("[share] form was canceled");
            bvModalEvt.preventDefault();
            this.formService.send({ type: 'CANCEL' });
        },
        onSave(bvModalEvt) {
            FL?.log?.debug("[share] form was submitted");
            this.formService.send({ type: 'SUBMIT', url: this.url });
            bvModalEvt.preventDefault();
        }
    }
}
</script>

<style>
.ShareIntentModal .modal-dialog {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
}
.modal-backdrop {
    opacity: 0.8;
}
</style>
